import { useContext } from 'react';
import { FeatureFlag } from '../types';
import { FeatureFlagContext } from '../components/FeatureFlagProvider';
import { getFlags, createFeatureFlagObject } from '../utils';
import { isEmpty } from '~/App/shared/utils';

export const useFeatureFlag = (flag: FeatureFlag) => {
  const { flags } = useContext(FeatureFlagContext);

  const data = isEmpty(flags) ? getFlags() : flags;
  const featureFlag = data?.[flag];

  return featureFlag ?? createFeatureFlagObject(false, false); // Return a default value
};
